module.exports = __webpack_public_path__ + "img/xiaofeijilu.a84b75e5.png";